/* eslint-disable no-unused-vars */

import React from "react"
import Grid from "@mui/material/Grid"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import IconButton from "@mui/material/IconButton"
import FacebookIcon from "@mui/icons-material/Facebook"
import InstagramIcon from "@mui/icons-material/Instagram"
import LinkedInIcon from "@mui/icons-material/LinkedIn"
import YouTubeIcon from "@mui/icons-material/YouTube"
// import XIcon from "@mui/icons-material/X"

const Footer = () => (
    <Grid container alignItems="center">
        <Grid
            item
            xs={12}
            sx={{
                padding: { xs: 2, md: 4 },
            }}
        >
            <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                width={"100%"}
                flexDirection={{ xs: "column", sm: "row" }}
            >
                <Grid
                    container
                    spacing={2}
                    display="flex"
                    // flexWrap={"wrap"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                >
                    <Box marginRight={2}>
                        <IconButton
                            variant="outlined"
                            color="primary"
                            component="a"
                            target="blank"
                            href="https://www.facebook.com/kaden.cowles"
                            size="small"
                        >
                            <FacebookIcon />
                        </IconButton>
                        <IconButton
                            variant="outlined"
                            color="primary"
                            component="a"
                            target="blank"
                            href="https://www.linkedin.com/in/kaden-cowles-67004a150/"
                            size="small"
                        >
                            <LinkedInIcon />
                        </IconButton>
                        <IconButton
                            variant="outlined"
                            color="primary"
                            component="a"
                            target="blank"
                            href="https://www.youtube.com/@KadenCowles-BeerHomeTeam"
                            size="small"
                        >
                            <YouTubeIcon />
                        </IconButton>
                        <IconButton
                            variant="outlined"
                            color="primary"
                            component="a"
                            target="blank"
                            href="https://www.instagram.com/kadencowles/"
                            size="small"
                        >
                            <InstagramIcon />
                        </IconButton>
                    </Box>
                    <Box>
                        <Button
                            variant="outlined"
                            color="primary"
                            component="a"
                            target="blank"
                            href=""
                            size="small"
                        >
                            Contact Us
                        </Button>
                    </Box>
                </Grid>
            </Box>
        </Grid>
        <Grid item xs={12}>
            <Typography
                align={"center"}
                variant={"subtitle2"}
                color="textSecondary"
                gutterBottom
            >
                &copy; KRISP. 2024. All rights reserved
            </Typography>
        </Grid>
    </Grid>
)

export default Footer
